// extracted by mini-css-extract-plugin
export default {"gift_card_value":"GiftCards_gift_card_value__F8NhP","gift_card_value_container":"GiftCards_gift_card_value_container__ORZq6"};